import { z } from 'zod';

/** Positions an athlete prefers; the position played in a match is recorded on the match roster. */
export const hockeyPositions = ['goalkeeper', 'defender', 'forward'] as const;
export type HockeyPosition = (typeof hockeyPositions)[number];

export const stickHands = ['left', 'right'] as const;
export type StickHand = (typeof stickHands)[number];

/**
 * Replaces the profile. It holds no sex or competition classification: those are collected only for
 * a selected competition and shown only to people who need them.
 */
export const saveHockeyProfileRequestSchema = z.strictObject({
  preferredPositions: z
    .array(z.enum(hockeyPositions))
    .max(hockeyPositions.length)
    .refine((positions) => new Set(positions).size === positions.length),
  stickHand: z.enum(stickHands).nullable(),
});
export type SaveHockeyProfileRequest = z.infer<typeof saveHockeyProfileRequestSchema>;

export interface HockeyProfileView {
  preferredPositions: HockeyPosition[];
  stickHand: StickHand | null;
  /** 0 when no profile exists yet; send it in `If-Match` when saving. */
  version: number;
}
